import authReady from '@gameday/core/actions/authReady';
import getIsFieldVisionSupported from '../helpers/isFieldVisionSupported';

const fieldVisionRequestAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const apicalls = [];
        const state = getState();
        const {
            config: {
                language = 'en',
                forceFieldVisionOn,
                enableWebEntitlement
            },
            gumbo: {
                gamePk
            } = {},
            userinfo: {
                accessToken,
                clientId,
                uid
            } = {},
            entitlements: {
                entitlementCodes
            } = {}
        } = state;

        apicalls.push(componentDataEngine.fetch('schedule', { gamePk, language }));
        const isFieldVisionSupported = getIsFieldVisionSupported(state);
        const isFVSupported = forceFieldVisionOn || (isFieldVisionSupported);
        const useWebFlow = (typeof window !== 'undefined' && window?.mlbOkta) || enableWebEntitlement;
        const shouldGetEntitlements = !!(useWebFlow && isFVSupported && typeof entitlementCodes === 'undefined');

        if (accessToken && clientId && uid) {
            apicalls.push({ accessToken, clientId, uid, stored: true }); // no need to save to the redux store
        } else {
            apicalls.push(dispatch(authReady));
        }

        return Promise.allSettled(apicalls)
            .then(([scheduleData, authInfoData]) => {
                if (scheduleData?.value) {
                    componentDataEngine.store(scheduleData?.value);
                }
                if (authInfoData?.value) {
                    const { accessToken, uid } = authInfoData?.value;
                    return [{ uid, accessToken }];
                } else {
                    return [];
                }
            }).then((data) => {
                if (shouldGetEntitlements && data?.length > 0) {
                    const { uid, accessToken } = data?.[0];
                    return componentDataEngine.fetchAndStore('entitlements', { uid, accessToken });
                }

                return data;
            }).catch((error) => {
                console.error('error', error);
            });
    };
};

export default fieldVisionRequestAction;
